
import './Announcement.css';

export const Announcement = () => {
    return <iframe className='game-frame' title="Storyverse Game" src="https://genesys.storyverse.games/production/web" />
};
